const CategoryRoutes = {
  getCategories: 'marketplace/categories',
};

export default CategoryRoutes